<template>
  <main class="main_container">
    <div class="product">
      <pulic-report-notice type="urgent" v-if="info.status === 'inactive'">
        <template #title>Product it not active</template>
      </pulic-report-notice>
      <Information class="box" v-bind="info">
        <template #deals>
          <a-skeleton :loading="spinning">
            <div style="margin-top: 28px; margin-bottom: 28px" v-if="info.productDeals?.length">
              <div class="deal-title">Deals</div>
              <ProductDeals :isCooperator="true" :dataSource="info.productDeals" :countryCode="info.countryCode" />
              <div class="subtitle">
                Note: The deals are provided by the seller themselves and
                haven't undergone verification. It is advisable to confirm the
                details of the deal with the seller prior to any promotion.
              </div>
            </div>
          </a-skeleton>
        </template>
      </Information>
      <div class="track-link" v-if="productTrackLink">
        <h2>Generate a Link</h2>
        <div class="fw500 camref">
          <span>* Camref</span>
          <artmisads-input size="middle" :value="cooperatorInfo.cooperationKey" disabled />
          <p v-if="!cooperatorInfo.cooperationKey" class="warning-tip">
            <i class="iconfont icon-a-warring-tianchong3" />Camref is required.
          </p>
        </div>
             <!-- Sub Tracking ID(Optional) -->
             <div class="source-options">
          <p class="sub-title">
            <span>Sub Tracking ID(Optional)</span>
          </p>
          <div class="option-item" ref="subTracking">
            <a-select :getPopupContainer="() => $refs.subTracking" placeholder="" class="source-select artmisads-select"
              v-model:value="subTrackingId" :options="subTrackingIdOptions" ref="sourceSelect"
              :open="subSourceSelectOpen" @dropdownVisibleChange="visible => subSourceSelectOpen = visible"
              :disabled="!cooperatorInfo.cooperationKey"
              :allowClear="true"
              @clear="onClearSubTrackingId"
              :dropdownStyle="{ overflow: 'unset' }" @select="(value, option) => onChangeSubTrackingId(value, option)">
              <template #dropdownRender="{ menuNode: menu }">
                <v-nodes :vnodes="menu" />
                <template v-if="cooperatorInfo.cooperationKey">
                  <a-divider style="margin: 8px 0" />
                  <Editable :allow-clear="true" @callback="onAddSubTrackingId" :style="{ margin: '0 auto 4px' }"
                    v-model:close="subSourceSelectOpen">
                    <template #default="slotProps">
                      <a href="javascript:;" class="source-edit" @click="slotProps.onClick">
                        <svg class="icon" aria-hidden="true" style="font-size: 16px; margin-right: 8px;">
                          <use xlink:href="#icon-jiahao-cu"></use>
                        </svg>
                        <span>New Sub Tracking ID</span>
                      </a>
                    </template>
                  </Editable>
                </template>
              </template>
              <template #suffixIcon>
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-jiantou-xia-cu"></use>
                </svg>
              </template>
            </a-select>
          </div>
        </div>
        <div class="fw500 link-textarea">
          <span :class="'link-copy-btn' +
            (cooperatorInfo.cooperationKey ? '' : ' disabled')
            " @click="copyTrackLink">
            <svg class="icon" aria-hidden="true" style="font-size: 22px">
              <use xlink:href="#icon-copy2"></use>
            </svg> </span>{{
              productTrackLink
                ? productTrackLink[
                (productTrackLink.shortLinkSelect ? 'short' : 'tracking') +
                'Link'
                ]
                : ''
            }}
        </div>
   
        <a-checkbox class="short-link" v-model:checked="productTrackLink.shortLinkSelect">Short Link</a-checkbox>
      </div>
      <variations v-if="info.variationTotal" :id="productId" userType="cooperate" :showStatus="false"
        @updateProductId="updateProductId" :countryCode="props.cooperatorInfo.countryCode" />
    </div>
  </main>
</template>

<script setup>
import { provide } from 'vue'
import { message } from 'ant-design-vue'
import { copyToClipboard } from '~/utils'
import { cooperatorApi } from '~/server/index'
import { onMounted, ref, watch, defineProps, defineComponent } from 'vue'

import Information from './information.vue'
import Variations from '~/components/variations.vue'
import ProductDeals from '~/components/ProductDeals.vue'
import PulicReportNotice from '~/components/PulicReportNotice.vue'
import Editable from '~/components/Editable.vue'
const VNodes = defineComponent({
    props: {
        vnodes: {
            type: Object,
            required: true,
        },
    },
    render () {
        return this.vnodes
    },
})
const productTrackLink = ref(null)
const props = defineProps(['productId', 'cooperatorInfo'])
const emit = defineEmits(['copyTrackLink'])
let productId = props.productId

provide('productId', productId)

const info = ref({})
const parentTrackingId = ref('')
const subTrackingId = ref('')
const subTrackingIdOptions = ref([])
const spinning = ref(true)
const subSourceSelectOpen = ref(false)

const getProductDetail = async (id) => {
  if (!productId && !id) return
  spinning.value = true

  const res = await cooperatorApi
    .getProductDetail(id ? id : productId, props.cooperatorInfo)
    .catch((e) => message.error('System error, please try again later.'))
  const { success, data } = res

  if (success) {
    if (id) {
      provide('productId', id)
      productId = id
    }

    info.value = data
  }

  if (productTrackLink.value?.trackingLink != undefined) {
    spinning.value = false
  }
}
const getSubTrackingIds = async () => {
 
 const res = await cooperatorApi.getTrackingIds({
   cooperationName: props.cooperatorInfo.cooperationName,
   trackingId:props.cooperatorInfo.cooperationKey,

 })
 // console.log(res,'res');
 parentTrackingId.value = res.data.id
 subTrackingIdOptions.value = res.data?.subTrackingIds?.map(item=>{
   return {
     label:item.trackingId,
     value:item.trackingId
   }
 })

}
 // 添加subid
 const onAddSubTrackingId = async (value) => {
  if (value.length > 20) {
    message.error('Exceeds length limit, please enter within 20 characters.')
    return
  }
  if (value && !/^[\u4e00-\u9fa50-9A-Za-z]+$/.test(value)) {
    message.error('Invalid format. Only Chinese characters, letters and numbers are allowed.')
    return
  }
 
  const res = await cooperatorApi.addTrackingIds({
    cooperationName: props.cooperatorInfo.cooperationName,
    trackingId: value,
    parentId: parentTrackingId.value,
    trackingIdType: 'SUB'
  })
  if(res.success){
    getSubTrackingIds()
  }else{
    message.error(res.error)
  }
}
const onChangeSubTrackingId = (value, option) => {
  getTrackLink(props.productId)
}
const onClearSubTrackingId = () => {
  subTrackingId.value = ''
  getTrackLink(props.productId)
}
async function getTrackLink (id) {
  const params = {
    id,
    cooperationName: props.cooperatorInfo.cooperationName,
    countryCode: props.cooperatorInfo.countryCode,
    primaryTrackingId:props.cooperatorInfo.cooperationKey,
    subTrackingId:subTrackingId.value?subTrackingId.value:undefined
  }

  // if (props.cooperatorInfo.cooperationKey) {
  //   params['cooperationKey'] = props.cooperatorInfo.cooperationKey
  // }

  cooperatorApi.getTrackLink(params).then(async (res) => {
    if (res.success) {
      productTrackLink.value = res.data
    } else {
      productTrackLink.value = { trackingLink: '' }
    }
    if (info.value.status) {
      // 详情已加载完毕
      spinning.value = false
    }
  })
}

// 复制链接
function copyTrackLink () {
  if (productTrackLink.value.trackingLink) {
    emit('copyTrackLink', {
      ...props.cooperatorInfo,
      ...productTrackLink.value,
      cooperationKey:props.cooperatorInfo.cooperationKey,
      subTrackingId:subTrackingId.value?subTrackingId.value:undefined
    })
  }
}

function updateProductId (id) {
  info.value = {}
  getTrackLink(id)
  getProductDetail(id)
}

onMounted(async () => {
  await getSubTrackingIds()
  getProductDetail()
  getTrackLink(productId)
})

watch(
  () => props.productId,
  async (val) => {  
    subTrackingId.value = ''
    info.value = {}
    if(val){
    await getSubTrackingIds()
    getTrackLink(val)
    getProductDetail(val)
  }
  }
)
</script>

<style scoped lang="less">
.main_container {
  .skeleton-loading {
    :deep(.ant-skeleton-image) {
      width: 300px;
      height: 300px;
      line-height: 300px;
    }
  }
}

.track-link {
  margin-top: 40px;

  >h2 {
    height: 27px;
    font-size: 20px;
    font-weight: 600;
    line-height: 27px;
    margin-bottom: 16px;
    color: var(--dark-1);
    letter-spacing: 0.4px;
    background: var(--color-white);
  }

  >.camref {
    font-size: 14px;
    line-height: 20px;
    color: var(--dark-2);
    letter-spacing: 0.4px;

    >.ant-input {
      font-size: 14px;
      margin-top: 6px;
      font-weight: 500;
      color: var(--dark-1);
      background: var(--bg-gray-2);

      &:hover {
        border: var(--border);
      }
    }
  }

  .link-textarea {
    height: 120px;
    font-size: 14px;
    margin-top: 24px;
    overflow-y: auto;
    user-select: none;
    position: relative;
    border-radius: 8px;
    margin-bottom: 15px;
    word-break: break-word;
    padding: 8px 72px 8px 12px;
    background: var(--bg-gray-2);
    border: 1px solid var(--border-1);
  }

  .short-link {
    width: 100%;
    justify-content: right;
  }
}

.link-copy-btn {
  cursor: pointer;
  display: block;
  position: absolute;
  right: 8px;
  top: 8px;
  display: flex;
  width: 56px;
  height: 64px;
  justify-content: center;
  align-items: center;
  background-color: var(--color-white);
  border-radius: 8px;

  &.disabled {
    cursor: not-allowed;

    svg {
      fill: var(--dark-4);
    }

    &:hover>svg {
      fill: var(--dark-4);
    }
  }

  svg {
    fill: var(--dark-3);
  }

  &:hover>svg {
    fill: var(--dark-2);
  }

  &:active>svg {
    fill: var(--dark-1);
  }
}

.product {
  display: flex;
  flex-direction: column;

  :deep(.report-notice) {
    margin-bottom: 0;
  }

  :deep(.product-variation) {
    >h2 {
      height: 28px;
      border: none;
      margin: 18px 0;
      line-height: 28px;
    }

    .header {
      height: 32px;
      margin-bottom: 16px;
    }
  }
}

.deal-title {
  font-size: 20px;
  font-weight: 600;
  color: var(--dark-1);
  letter-spacing: 0.5px;
  margin-bottom: 14px;
}

.subtitle {
  margin-top: -8px;
  color: var(--dark-3);
}
.source-options {
  width: 40%;
  margin-top:18px ;
}
.sub-title {
  display: flex;
  align-items: center;
  color: var(--dark-2);
  font-weight: 500;
  font-size: 14px;

  .icon {
    font-size: 14px;
    margin-left: 5px;
    color: var(--dark-4);
  }

  :deep(.ant-tooltip-inner) {
    font-size: 13px;
    padding: 6px 12px !important;
    line-height: 18px;
    min-width: 300px !important;
  }
}
.option-item {
  :deep(.ant-select) {
    &-disabled {
      .ant-select-selector {
        background: var(--bg-gray-2);
        box-shadow: var(--section-box-shadow-2);
        border: 1px solid var(--border-1) !important;

        .ant-select-selection-item {
          color: var(--dark-4);
        }
      }

      &:hover .ant-select-selector {
        border-color: var(--border-1);
      }
    }

    &-item {
      margin: 0 4px;
      font-weight: 400;
      color: var(--dark-1);

      &:hover {
        background: var(--bg-gray-6);
      }

      &:active {
        background: var(--bg-gray-4);
      }

      &-option-selected {
        position: relative;
        font-weight: normal;
        background-color: var(--select-bg-1);

        &::after {
          top: 8px;
          right: 8px;
          width: 16px;
          height: 16px;
          content: '';
          position: absolute;
          background: url(../../../../assets/images/svg/select_gou.png);
          background-size: 100%;
        }
      }
    }
  }
}
.option-item {
  margin-top: 8px;

  .tracking-tag {
    display: flex;
    flex-direction: column;
    gap: 4px;

    label {
      display: inline-flex;
      align-items: center;
      color: var(--dark-2);
      font-weight: 400;
      font-size: 14px;
      height: 20px;
    }

    a {
      margin-left: 24px;
      text-decoration: underline;
      color: var(--dark-3);
      font-size: 12px;
      font-weight: 400;
      display: block;
      padding-bottom: 8px;
    }
  }

  .track-tag-input {
    display: block;
    margin: 6px 0 0 24px;
    width: 251px;
    height: 32px;
    padding: 0 11px;
    position: relative;
    background-color: var(--color-white);
    border: 1px solid #d9d9d9;
    transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    box-sizing: border-box;
    font-size: 14px;
    line-height: 1.5714285714285714;
    list-style: none;
    display: flex;
    border-radius: 8px;
    color: var(--dark-1);

    &:focus {
      outline: none;
      border: 1px solid var(--primary-border-2) !important;
      box-shadow: var(--section-box-shadow-4) !important;
    }
  }

  .source-select {
    display: block;
    width: 275px;
  }

  .add-source {
    margin: 6px 0 0 24px;
  }
}
.source-edit {
  position: relative;
  cursor: pointer;
  margin: 0 auto;
  display: flex;
  color: var(--dark-2);
  background-color: var(--bg-gray-1);
  width: 260px;
  height: 32px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px dashed var(--border-1);
}
</style>